// extracted by mini-css-extract-plugin
export default {"root":"CancelRenewSection_root__iqUkE"};